<template>
    <div class='adminMain'>
        <div class="header">
          <div class='lf xtName'>{{title}}</div>
          <p class='lf'>
           <el-button type="btn" :class='[{active:lx=="1"}]' @click='lx=1'>采购</el-button>
           <el-button type="btn" :class='[{active:lx=="2"}]' @click='lx=2'>工程</el-button>
          </p>
          <div class='rt'>
            <span v-if='user'>欢迎您：<span>{{user}}</span></span>
            <button v-if='user' type='button' @click='loginOut'>退出</button>
            <button v-else type='button'>驱动下载</button>
          </div>
        </div>
        <!-- 一级菜单 -->
        <Aside></Aside>
        <router-view class="rightContent" :adminLx='lx'></router-view>
    </div>
</template>
<script>
import Aside from "../components/aside";
import { title } from "@/settings";
export default {
  components: {Aside},
  name: "admin",
  data() {
    return {
      lx:1
    };
  },
  computed:{
    user(){
      return localStorage.getItem('user')?localStorage.getItem('user'):''
    },
    title(){
      return title;
    }
  },
  methods:{
    loginOut(){
      this.$router.push('/logout')
    },
  },
  mounted(){
    if(localStorage.getItem('role')=='M'){
      this.$router.push("/zygl");
    }else{
      this.$router.push("/kbxmList");
    }
  },
};
</script>
<style lang="less">
.adminMain {
  min-width: 1200px;
  position:relative;
  height: auto !important;
  min-height: 100%;

.rightContent{
  margin-left:235px;
  padding:10px;
  .searchBox{
    background:@base-Bg;
    padding:10px;
    border:1px solid #ddd;
    .el-form--inline .el-form-item__label{
      min-width:80px;
    }
    .el-form--inline .el-form-item{
      margin-bottom:0px;
    }
    .el-button{
      min-width: 80px;
    }
  }
  .btnsBox{
    .el-button{
      margin:8px 10px 8px 0;
      min-width: 80px;
    }
  }
}
}
#app button.el-button--btn{
  border:1px solid #fff;
  width: 80px;
}
#app button.el-button--btn.active{
  background:#fbe7ea;
  color:@base-color;
}
</style>
